import { styled } from '@mui/material';

import { ReactNode } from 'react';

import { ArrowForwardIcon } from '@app-velocity/icons';

const PreviewContainer = styled('div')({
  position: 'relative',
  display: 'block',
  width: '100%',
  maxWidth: '100%',
});

const NavButton = styled('button', {
  shouldForwardProp: (prop) => prop !== 'side',
})<{ side: 'left' | 'right' }>(({ theme, side }) => ({
  position: 'absolute',
  top: '50%',
  [side]: theme.spacing(4),
  border: 'none',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transform:
    side === 'left' ? 'translateY(-50%) rotate(180deg)' : 'translateY(-50%)',
  zIndex: 10,
  borderRadius: '50%',
  background: 'rgba(0,0,0,0.7)',
  width: theme.spacing(8),
  height: theme.spacing(8),
  svg: {
    fill: '#fff',
    width: 20,
    height: 20,
  },
}));

export type PreviewNavigationProps = {
  children: ReactNode;
  onPrevious: () => void;
  onNext: () => void;
};

export const PreviewNavigation = ({
  children,
  onPrevious,
  onNext,
}: PreviewNavigationProps) => {
  return (
    <PreviewContainer>
      <NavButton type="button" side="left" onClick={onPrevious}>
        <ArrowForwardIcon />
      </NavButton>

      <NavButton type="button" side="right" onClick={onNext}>
        <ArrowForwardIcon />
      </NavButton>

      {children}
    </PreviewContainer>
  );
};
